























































  import {Component, Vue} from 'vue-property-decorator';
  import {Category, Collection} from "../model";
  import {apiService} from "../services/api-service";
  import CartIndicator from '@/components/CartIndicator.vue';

  @Component({
    components: { CartIndicator }
  })
  export default class Navbar extends Vue {

    categories:Category[] = [];
    collections:Collection[] = [];

    created() {
      this.loadCategories();
      this.loadCollections();
    }

    async loadCategories() {
      this.categories = await apiService.loadCategories();
    }

    async loadCollections() {
      this.collections = await apiService.loadCollections();
    }

    goToCategory (cat:Category) {
      this.$router.push(`/category/${cat.id}`);
      this.toggleMenu();
    }

    goToCollection (col:Collection) {
      this.$router.push(`/collection/${col.id}`);
      this.toggleMenu();
    }

    // noinspection JSMethodCanBeStatic
    toggleMenu () {
      let element:HTMLLinkElement|null = document.querySelector('.navbar-burger');

      if (element) {
        // Get the target from the "data-target" attribute
        let targetId = (element.dataset as any).target;
        let target = document.getElementById(targetId);

        // Toggle the class on both the "navbar-burger" and the "navbar-menu"
        element.classList.toggle('is-active');
        if (target) {
          target.classList.toggle('is-active');
        }
      }

    }

}
